import api from 'services/api';
import {
  SupportTicketList,
  SupportTicketPriority,
  SupportTicketResponse,
  SupportTicketStatus,
  SupportTicketType,
} from 'models/supportTickets.model';
import { ListResponseComplete } from 'models/general.model';
import { SupportTicketStatusType } from 'core/domain/supportTickets/models/supportTicketsPayloadModel';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const getSupportTicket = async (techSupportId: string): Promise<SupportTicketResponse> => {
  return await api.get(`/support-tickets/${techSupportId}`);
};

interface GetSupportTicketsOptions {
  host: string;
  token: string;
  assetId?: string;
  pageNumber?: number;
  pageSize?: number;
  priority?: SupportTicketPriority;
  sort?: string;
  status?: SupportTicketStatus;
  type?: SupportTicketType;
}

const getUrl = ({
  host,
  assetId,
  pageNumber,
  pageSize,
  priority,
  sort,
  status,
  type,
}: {
  host: string;
  assetId?: string;
  pageNumber?: number;
  pageSize?: number;
  priority?: SupportTicketPriority;
  sort?: string;
  status?: SupportTicketStatus;
  type?: SupportTicketType;
}) => {
  const params = new URLSearchParams();
  assetId && params.append('asset_id', assetId);
  pageNumber && params.append('page[number]', String(pageNumber));
  pageSize && params.append('page[size]', String(pageSize));
  priority && params.append('priority', priority);
  sort && params.append('page[sort]', sort);
  status && params.append('status', status);
  type && params.append('type', type);

  return `${host}/support-tickets?${params}`;
};

export const getSupportTickets = async ({
  host,
  token,
  assetId,
  pageNumber,
  pageSize,
  priority,
  sort,
  status,
  type,
}: GetSupportTicketsOptions): Promise<ListResponseComplete<SupportTicketList>> => {
  try {
    const url = getUrl({
      host,
      assetId,
      pageNumber,
      pageSize,
      priority,
      sort,
      status,
      type,
    });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '2',
      },
    };

    const response = (await axios(options)) as AxiosResponse<any>;
    return response.data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateSupportTicketStatus = async (
  techSupportId: string,
  newData: { status: SupportTicketStatusType; description: string }
): Promise<void> => {
  const transformedStatus = newData.status.toLowerCase();
  const data = { ...newData, status: transformedStatus };

  return await api.patch(`/support-tickets/${techSupportId}`, {
    data,
  });
};
